import { createFilterStore, FilterState } from "@faire/retailer-visitor-shared/components/Filters/FilterStore";
import * as React from "react";
export var FilterContext = React.createContext(createFilterStore(FilterState.build(), {
    current: function() {}
}));
